import { render } from "./EmployeesList.vue?vue&type=template&id=fb16b1fc&scoped=true"
import script from "./EmployeesList.vue?vue&type=script&lang=js"
export * from "./EmployeesList.vue?vue&type=script&lang=js"

import "./EmployeesList.vue?vue&type=style&index=0&id=fb16b1fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb16b1fc"]])

export default __exports__